import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Project } from './project.model';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {
  project?: Project[];
  // private project: Project[];
  constructor(private http: HttpClient) { }

  // getProjectData(){
  //   return this.http.get<Project>(`${environment.fireBase}project.json`).pipe(map(projects => {
  //     return projects.map((project: any) => {
  //       return
  //     })
  //   }))
  // }
  getProjectData() {
    return this.http.get<Project>(`${environment.fireBase}project.json`)
  }

  setProjects(project: Project[]){
    this.project = project
  }
  getProjects(){
    return this.project?.slice()
  }

  getProject(index: number){
    return this.project![index];
  }
  doAddProjects(body: any){
    return this.http.post(`${environment.express}projects/add-project`, body)
  }


}
